import { RUM, RUMError } from 'packages/rum';

const datadogLogger = (error, context) => {
  const rumError = new RUMError(error.message, context);

  RUM.getInstance()?.sendError(rumError);
};

export default datadogLogger;
